<template>
  <div>
    <div class="pa-3">
      <v-container>
        <div style="text-align: center" class="py-2 mb-3">
          <img style="height: 50%; width: 70px" src="../assets/logo.svg" />
        </div>
        <div v-if="!loading">
          <v-row>
            <v-col cols="4">
              <div class="text-center">
                <v-avatar size="90">
                  <img :src="data.profile_pic" />
                </v-avatar>
              </div>
            </v-col>
            <v-col cols="8">
              <div style="color: #198cd0; font-weight: 600; font-size: 18px">
                {{ data.name }}
              </div>
              <div style="font-size: x-small">
                <v-icon
                  style="font-size: larger; color: #74c374; margin-right: 4px"
                  >mdi-hammer-wrench</v-icon
                >
                ช่าง
              </div>
              <div>
                <star-rating
                  :inline="true"
                  :rating="
                    data.average_review ? parseFloat(data.average_review) : 0
                  "
                  :read-only="true"
                  :rounded-corners="true"
                  :star-size="20"
                  :increment="0.1"
                ></star-rating>
                <span class="ml-1" style="font-size: 12px"
                  >({{
                    data.total_review ? parseFloat(data.total_review) : 0
                  }})</span
                >
              </div>
            </v-col>
          </v-row>
          <div>
            <v-divider></v-divider>
          </div>
          <div class="pb-16">
            <v-row dense>
              <v-col
                v-for="(img, k) in data.painter_works"
                :key="img + k"
                cols="4"
              >
                <v-img
                  @click="
                    showimg = img;
                    showimgdialog = true;
                  "
                  aspect-ratio="1.3"
                  class="grey darken-2"
                  :src="img"
                  :lazy-src="img"
                ></v-img>
              </v-col>
            </v-row>
            <v-dialog v-model="showimgdialog">
              <div v-if="showimgdialog">
                <v-img
                  @click="
                    showimgdialog = false;
                    showimg = '';
                  "
                  class="grey darken-2"
                  :src="showimg"
                  :lazy-src="showimg"
                ></v-img>
              </div>
            </v-dialog>
          </div>
        </div>
        <div v-else class="text-center pt-9">
          <v-progress-circular
            indeterminate
            color="primary"
            size="70"
          ></v-progress-circular>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
import axios from "axios";
export default {
  data() {
    return {
      loading: true,
      data: {},
      showimg: "",
      showimgdialog: "",
    };
  },
  components: {
    StarRating,
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  },
  methods: {
    getData() {
      return new Promise((resolve) => {
        var vm = this;
        axios
          .get(
            "https://communitybotbyzwizai.herokuapp.com/toapainterprotfolio",
            {
              params: {
                userid: vm.query.userid,
                pageid: vm.query.pageid,
              },
              headers: {
                AUTHORIZATION: "Bearer xxx xxx",
              },
            }
          )
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              vm.data = response.data.data;
              resolve();
            } else {
              await vm.$swal.fire({
                icon: "error",
                text: response.data.reason,
              });
              if (this.query.apptype == "line") {
                await this.$liff.closeWindow();
              } else if (this.query.apptype == "facebook") {
                this.$store.dispatch("messengerClose");
              }
              resolve();
            }
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>